// extracted by mini-css-extract-plugin
export default {"cat_item":"styles_cat_item__+AkNZ"};